import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';

import {
    Box, Divider, Typography, Grid, Button, Container, FormControl, TextField,
    Paper, CircularProgress, TableRow, TableCell, Table, TableContainer, TableHead, TableBody,
    Dialog, DialogTitle, DialogContent, DialogActions,
    InputLabel, MenuItem, Select, Autocomplete
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useTheme } from '@mui/material/styles'

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import CustomStatusChip from '../../utils/components/CustomStatusChip';
import { getDate, formatMoney, usuarios } from '../../utils/functions/Utils';

import FormatoValeSalida from '../formatos/FormatoValeSalida';

function SalidaProductos() {
    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const theme = useTheme()

    const [data, setData] = useState({
        noSolicitud: '',
        solicitante: '',
        noOrden: '',
        estatus: '',
        recibe: '',
        observaciones: '',
    });

    const [recibe, setRecibe] = useState('');
    const [entrega, setEntrega] = useState('');
    const [autoriza, setAutoriza] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [fechaDeEntrega, setFechaDeEntrega] = useState(DateTime.now());

    const [clientes, setClientes] = useState([
        { id: 1, nombre: 'Cliente 1' },
        { id: 2, nombre: 'Cliente 2' },
        { id: 3, nombre: 'Cliente 3' },
        { id: 4, nombre: 'Cliente 4' },
        { id: 5, nombre: 'Cliente 5' },
    ]);
    const [cliente, setCliente] = useState({ name: '', rfc: '', address: '', phone: '', email: '', contact: '' });

    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([{}]);

    const [inventory, setInventory] = useState({});

    const [motivo, setMotivo] = useState('venta');
    const [motivos, setMotivos] = useState(['venta']);

    const [modalEdit, setModalEdit] = useState(false);
    const [currentProduct, setCurrentProduct] = useState({ clave: '', nombre: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0 });
    const [cotizacion, setCotizacion] = useState({});

    const [authKey, setAuthKey] = useState('');

    const [showVerification, setShowVerification] = useState(false);

    const [requestDate, setRequestDate] = useState(DateTime.now());

    const [infoServicio, setInfoServicio] = useState({
        noReporte: '', equipo: '', marca: '', modelo: '', noSerie: '', noInventario: '', fechaReporte: DateTime.now(), hospital: '', area: '', observaciones: ''
    });
    const [hospital, setHospital] = useState('');
    const [hospitales, setHospitales] = useState([])

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    const estatus = ['Pendiente de validación', 'Entregado', 'Devolución', 'Cancelado'];
    const admins = ['Abdias Lopez', 'Jorge Benítez', 'Eduardo Alanis', 'Daniel Cruz'];

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Tecnico', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Salida de productos';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
        getData();
        return () => {
            document.body.style.backgroundColor = theme.palette.background.default;
        }
    }, [])

    const getData = async () => {
        setLoading(true);
        try {
            let tmp;
            let res = await axios.get(`/api/deliveries/${id}`);
            if (res.status === 200) {
                tmp = res.data;
                setData(res.data);
                setRecibe(res.data.recibe ? res.data.recibe : '');
                setEntrega(res.data.entrega ? res.data.entrega : '');
                setAutoriza(res.data.auth ? res.data.auth : '')
                setObservaciones(res.data.observaciones ? res.data.observaciones : '');
                setFechaDeEntrega(res.data.fechaDeEntrega ? DateTime.fromISO(res.data.fechaDeEntrega) : DateTime.now());
                setMotivo(res.data.motivo);
                setInfoServicio(res.data.infoServicio ? res.data.infoServicio : { noReporte: '', hospital: '' })
                setHospital(res.data.infoServicio ? res.data.infoServicio.hospital : '');
                document.title = `Salida de productos - ${data.noSolicitud}`;
                if (res.data.cliente) {
                    setCliente(res.data);
                } else {
                    setCliente({ name: tmp.cliente, rfc: '', address: '', phone: '', email: '', contact: '' });
                }
                const array = res.data.productos.map((item) => { return item.id });
                const products = await axios.post(`/api/products/array`, { array: array });
                if (products.status === 200) {
                    const prd = tmp.productos.map((item, i) => {
                        return {
                            ...item,
                            ubicacion: products.data[i].ubicacion.almacen.replace('ELECTROMEDICA', 'E.') + ' - ' +
                                products.data[i].ubicacion.anaquel + ' - ' +
                                products.data[i].ubicacion.nivel + ' - ' +
                                products.data[i].ubicacion.posicion,
                        }
                    })
                    setData({ ...tmp, productos: prd });
                    setProducts(products.data);
                    setRequestDate(DateTime.now());
                }

                if (res.data.noMovimiento) {
                    const tmpInv = await axios.get(`/api/inventories/number/${res.data.noMovimiento}`);
                    if (res.status === 200) {
                        setInventory(tmpInv.data);
                    }
                }
            }
            res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setMotivos(res.data.motivosSalida);
            }

            res = await axios.get('/api/clients/');
            if (res.status === 200) {
                setClientes(res.data);
            }
            res = await axios.get('/api/hospitals/');
            if (res.status === 200) {
                setHospitales(res.data);
            }
            setLoading(false);

        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar la solicitud de salida de almacén, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
            setLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const tmp = {
            ...inventory,
            motivo: motivo,
            salida: {
                ...inventory.salida,
                fechaDeSalida: fechaDeEntrega,
                recibe: recibe,
                entrega: entrega,
            },
            observaciones: observaciones,
            auth: autoriza,
            estatus: 'Consolidado',
        }

        if (data.operacion === 'Servicio') {
            tmp.salida.infoServicio = {
                noReporte: infoServicio.noReporte,
                hospital: hospital
            }
        }
        setInventory(tmp);

        setShowVerification(true);
    }

    const renderVerification = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showVerification}
                className='exo2'
                scroll='paper'
                onClose={handleCloseVerification}>
                <DialogTitle variant='h5'>Confirmar salida de material</DialogTitle>
                <DialogContent>
                    <div>
                        <Typography>Material Solicitado</Typography>
                        <Grid container spacing={1}>
                            <Grid item sm={12}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow hover >
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.productos.map((ref, i) => (
                                                <TableRow hover key={ref.id}>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        <hr style={{ margin: '24px 0px' }} />
                        <form onSubmit={(e) => handleVerificar(e)}>
                            <Grid container spacing={1}>
                                <Grid item sm={12} >
                                    <p></p>
                                    <FormControl sx={{ m: 1, minWidth: 100, maxWidth: '500px' }} style={{ display: 'flex' }}>
                                        <TextField required type='password' label="Llave de verificación" variant="outlined" value={authKey} onChange={(e) => setAuthKey(e.target.value)} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                                    <Button variant='contained' color='primary' className='m-1 p-2' type='submit' >&nbsp;Confirmar solicitud &nbsp;&nbsp;<i className='fad fa-badge-check' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </DialogContent>
                <hr />
                <DialogActions>
                    <Button color='error' variant='contained' onClick={() => handleCloseVerification()}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleCloseVerification = () => {
        setShowVerification(false);
    }

    const handleVerificar = async (e) => {
        e.preventDefault();

        try {
            let res = await axios.post(`/api/inventories/${inventory._id}`, { inventory: inventory });
            if (res.status === 200) {
                const delivery = {
                    ...data,
                    estatus: 'Entregado',
                    recibe: recibe,
                    entrega: entrega,
                    observaciones: observaciones,
                    fechaDeEntrega: fechaDeEntrega,
                    solicitudAtendida: true,
                    auth: autoriza,
                    motivo: motivo,
                }
                if (data.operacion === 'Servicio') {
                    delivery.infoServicio = {
                        noReporte: infoServicio.noReporte,
                        hospital: hospital
                    }
                }
                if (data.noOrden) {
                    try {
                        res = await axios.get(`/api/orders/number/${data.noOrden}`);
                        if (res.status === 200) {
                            if (res.data.estatus !== 'Entregado') {
                                const order = {
                                    ...res.data,
                                    estatus: 'Surtido',
                                }
                                res = await axios.post(`/api/orders/${res.data._id}`, { order: order });
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                }
                res = await axios.post(`/api/deliveries/${id}`, { delivery: delivery });
                if (res.status === 200) {

                    setApiRes(state => { return { ...state, show: true, message: 'Se ha validado la salida de los productos', severity: 'success' } });
                    setTimeout(() => {
                        navigate('/inventario/salidas');
                    }, 800);
                }
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
            console.log(err);
        }
    }

    const handleUpdateVale = async (e) => {
        e.preventDefault();

        try {
            const delivery = {
                ...data,
                estatus: data.estatus,
                recibe: recibe,
                entrega: entrega,
                observaciones: observaciones,
                fechaDeEntrega: fechaDeEntrega,
                solicitudAtendida: data.solicitudAtendida,
                auth: autoriza,
                motivo: motivo,
            }

            if (data.operacion === 'Servicio') {
                delivery.infoServicio = {
                    noReporte: infoServicio.noReporte,
                    hospital: hospital
                }
            }
            const res = await axios.post(`/api/deliveries/${id}`, { delivery: delivery });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Se actualizó la informacion del vale de salida', severity: 'success' } });
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
            console.log(err);
        }
    }

    useEffect(() => {
        updateCotizacion(products);
    }, [products])

    const updateCotizacion = (d) => {
        let subtotal = d.reduce(function (tot, arr) {
            return tot + arr.precioUnitario * arr.cantidad;
        }, 0);

        const iva = subtotal * 0.16;
        const total = subtotal + iva;

        setCotizacion({ subtotal: subtotal, iva: iva, total: total });
    }

    const handleDelete = async (d, r) => {
        if (r < 2) {
            setData({ ...data, productos: [] });
        } else {
            const newProducts = data.productos.filter(x => x.key !== d)
            setData({ ...data, productos: newProducts });
            const array = newProducts.map((item) => { return item.id });
            const tmp = await axios.post(`/api/products/array`, { array: array });
            if (tmp.status === 200) {
                setProducts(tmp.data);
                setRequestDate(DateTime.now());
            }
        }
    }

    const handleEdit = (d) => {
        setModalEdit(true);
        setCurrentProduct(d);
    }

    const handleCloseEdit = () => {
        setModalEdit(false);
        setCurrentProduct({ clave: '', nombre: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0 });
    }

    const handleUpdateRefaccion = async (d, e) => {
        setModalEdit(false);
        const newProducts = data.productos.map(r => r.key === e ? d : r)
        setData({ ...data, productos: newProducts });
        const array = newProducts.map((item) => { return item.id });
        const tmp = await axios.post(`/api/products/array`, { array: array });
        if (tmp.status === 200) {
            setProducts(tmp.data);
            setRequestDate(DateTime.now());
        }
    }

    const renderEditModal = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEdit}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEdit}>
                <DialogTitle >Editar producto</DialogTitle>
                <DialogContent>
                    {currentProduct ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Clave" variant="outlined" value={currentProduct.clave} onChange={(e) => setCurrentProduct({ ...currentProduct, clave: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Producto" variant="outlined" multiline value={currentProduct.nombre} onChange={(e) => setCurrentProduct({ ...currentProduct, nombre: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Cantidad" variant="outlined" value={currentProduct.cantidad} onChange={(e) => setCurrentProduct({ ...currentProduct, cantidad: Number(e.target.value) })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateRefaccion(currentProduct, currentProduct.key)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEdit()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {loading ?
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :

                <Paper sx={{ padding: '24px' }} elevation={3}>
                    <Container maxWidth='xl'>
                        <Box className='text-center' >
                            <Typography variant='h5' style={{ fontWeight: 700 }}>Validación de salida de productos de almacén</Typography>
                        </Box>

                        <Button size='small' variant='outlined' onClick={() => navigate('/inventario/salidas')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                        <Divider className='my-4' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la solicitud' className='text-bold' />
                        </Divider>

                        <div style={{ maxHeight: '90px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                            <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'># Cotización:</p>
                                <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.noOrden ? data.noOrden : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Solicita:</p>
                                <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.solicitante ? data.solicitante : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Operacion:</p>
                                <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.operacion ? data.operacion : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Descripción:</p>
                                <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.descripcion ? data.descripcion : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Fecha de solicitud:</p>
                                <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.fechaDeSolicitud ? getDate(data.fechaDeSolicitud) : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Estatus:</p>
                                <div style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'><CustomStatusChip label={data.estatus ? data.estatus : ''} estatus={data.estatus ? data.estatus : ''} /></div>
                            </div>
                        </div>
                        <p></p>

                        <Grid container>
                            {
                                ['Admin', 'Almacen', 'Ayudante'].includes(auth.user.rol) ?
                                    <Grid item sm={12}>
                                        <Divider className='my-4' textAlign="left">
                                            <CustomChip variant='outlined' estatus='ATENDIDO' label='Disponibilidad de productos en el almacén' className='text-bold' />
                                        </Divider>
                                        <Typography sx={{ margin: '0px 8px', color: 'comp.gray' }} variant='body1'>Consulta: {getDate(requestDate, 'DD, HH:mm:ss')} hrs</Typography>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow hover >
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#47A99222' }} colSpan={4}>Detalles</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#C147E922' }} colSpan={4} >Ubicación</TableCell>
                                                    </TableRow>
                                                    <TableRow hover sx={{ backgroundColor: 'comp.tableHeaderBg' }}>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad Disponible</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Descripcion</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Almacén</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Anaquel</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Nivel</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Posición</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {products.map((ref, i) => (
                                                        <TableRow hover key={`${ref._id}Alm`} sx={{ backgroundColor: 'comp.tableBg' }}>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.descripcion}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em', minWidth: '135px' }} align='center'>{ref.ubicacion.almacen}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em', minWidth: '135px' }} align='center'>{ref.ubicacion.anaquel}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em', minWidth: '135px' }} align='center'>{ref.ubicacion.nivel}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em', minWidth: '135px' }} align='center'>{ref.ubicacion.posicion}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid> : <></>
                            }

                            <Grid item sm={12} sx={{ border: 'solid 1px #555577', padding: '24px', borderRadius: '20px', marginTop: '64px' }}>
                                <Divider className='mb-4' textAlign="left">
                                    <CustomChip variant='outlined' estatus='EN REPARACIÓN' label='Productos solicitados' className='text-bold' />
                                </Divider>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow hover >
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#ABC27022' }} colSpan={5}>Detalles</TableCell>
                                                {/* <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}colSpan={2} >Acciones</TableCell> */}
                                            </TableRow>
                                            <TableRow hover >
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad Solicitada</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Descripcion</TableCell>
                                                {/* <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}></TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.productos.map((ref, i) => (
                                                <TableRow hover key={`${ref.id}Cot`}>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.descripcion}</TableCell>
                                                    {/* {
                                                            data.solicitudAtendida ? <></> :
                                                            <TableCell size='small' align='center'>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Button sx={{ minWidth: '110px' }} variant='contained' color='primary' className='m-1' onClick={() => handleEdit(ref)}>Editar &nbsp;&nbsp;<i className='fad fa-edit'></i></Button>
                                                                    <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleDelete(ref.key, data.productos.length)}>&nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                                                </div>
                                                            </TableCell>
                                                        } */}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <br />

                                {
                                    ['Admin', 'Almacen'].includes(auth.user.rol) ?
                                        <form onSubmit={(e) => handleSubmit(e)}>
                                            <Grid container spacing={3}>
                                                <Grid item sm={12} md={4}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            freeSolo={true}
                                                            onInputChange={(event, newInputValue) => setRecibe(newInputValue)}
                                                            inputValue={recibe}
                                                            options={usuarios}
                                                            renderInput={(params) => <TextField {...params} label='Recibe' required />}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            freeSolo={true}
                                                            onInputChange={(event, newInputValue) => setEntrega(newInputValue)}
                                                            inputValue={entrega}
                                                            options={usuarios}
                                                            renderInput={(params) => <TextField {...params} label='Entrega' required />}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            freeSolo={true}
                                                            onInputChange={(event, newInputValue) => setAutoriza(newInputValue)}
                                                            inputValue={autoriza}
                                                            options={admins}
                                                            renderInput={(params) => <TextField {...params} label='Autoriza' required />}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={5}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <TextField multiline disabled={data.solicitudAtendida} label="Descripción" variant="outlined" value={data.descripcion} onChange={(e) => setData({ ...data, descripcion: e.target.value })} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <InputLabel id="select">Motivo de salida</InputLabel>
                                                        <Select
                                                            disabled={data.solicitudAtendida}
                                                            labelId="select"
                                                            value={motivo}
                                                            label="Motivo de salida"
                                                            onChange={(e) => setMotivo(e.target.value)}
                                                        >
                                                            {motivos.map((x, i) => (
                                                                <MenuItem key={i} value={x}>{x}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <DatePicker
                                                            label="Fecha de Entrega"
                                                            format="dd/MM/yyyy"
                                                            value={fechaDeEntrega}
                                                            onChange={(newValue) => setFechaDeEntrega(newValue)}
                                                            slotProps={{ textField: { variant: 'outlined' } }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item sm={12} md={6}>
                                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                                        <TextField label="Observaciones" multiline variant="outlined" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item sm={12} md={2}>
                                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                                        <TextField disabled label="# Movimiento" multiline variant="outlined" value={data.noMovimiento} />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item sm={12} md={6}>
                                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                                        <TextField disabled label="Cliente" variant="outlined" value={data.cliente} />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            freeSolo={true}
                                                            onInputChange={(event, newInputValue) => setData({ ...data, estatus: newInputValue })}
                                                            inputValue={data.estatus}
                                                            value={data.estatus}
                                                            defaultValue={data.estatus}
                                                            options={estatus}
                                                            renderInput={(params) => <TextField {...params} label='Estatus' />}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                {
                                                    data.operacion === 'Servicio' ?
                                                        <>
                                                            <Grid item xs={12} md={6} lg={4}>
                                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                                    <TextField required label="# Reporte/Servicio" variant="outlined" value={infoServicio.noReporte} onChange={(e) => setInfoServicio({ ...infoServicio, noReporte: e.target.value })} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} >
                                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                                    <Autocomplete
                                                                        disablePortal
                                                                        freeSolo={auth.user.rol === 'Tecnico' ? false : true}
                                                                        onInputChange={(event, newInputValue) => setHospital(newInputValue)}
                                                                        inputValue={hospital}
                                                                        aria-multiline='true'
                                                                        options={hospitales.map((option) => option.name)}
                                                                        renderInput={(params) => <TextField required {...params} label='Unidad hospitalaria' />}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                        </> : <></>
                                                }

                                                <Grid item sm={12}>
                                                    <div className='d-flex justify-content-end'>
                                                        <Button size='large' variant='contained' color='info' className='m-1' onClick={(e) => handleUpdateVale(e)}>Actualizar Vale &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                                                        {
                                                            ['Admin', 'Almacen'].includes(auth.user.rol) && !data.solicitudAtendida ?
                                                                <Button size='large' disabled={data.solicitudAtendida} variant='contained' color='success' className='m-1' type='submit'>Confirmar salida &nbsp;&nbsp; <i className='fad fa-badge-check' style={{ transform: 'scale(1.3)' }}></i></Button>
                                                                : <></>
                                                        }
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </form> : <></>
                                }
                                {
                                    !['Admin', 'Almacen'].includes(auth.user.rol) ?
                                        <Grid item sm={12} md={4}>
                                            <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                <Autocomplete
                                                    disablePortal
                                                    freeSolo={true}
                                                    onInputChange={(event, newInputValue) => setRecibe(newInputValue)}
                                                    inputValue={recibe}
                                                    options={usuarios}
                                                    renderInput={(params) => <TextField {...params} label='Recibe' required />}
                                                />
                                            </FormControl>
                                        </Grid> : <></>
                                }
                            </Grid>
                        </Grid>

                        {renderVerification()}
                        {renderEditModal()}

                    </Container>
                </Paper>
            }
            {loading ? <></> :
                <Container maxWidth='xl'>
                    <FormatoValeSalida data={data} recibe={recibe} autoriza={autoriza} productos={data.productos} cotizacion={data.cotizacion} cliente={data.cliente} infoServicio={data.infoServicio} solicitante={data.solicitante} salida={{ fechaDeSolicitud: data.fechaDeSolicitud, entrega: data.solicitudAtendida ? data.auth : auth.user.name, fechaDeEntrega: fechaDeEntrega }} userType={auth.user.rol} company={auth.user.company} />
                </Container>
            }
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />

        </Container>
    );
}

export default SalidaProductos;